/* ---------- スムーススクロール ---------- */
import { smoothScroll } from "./include/module";
smoothScroll();



// ------------------------------------------------------------------------
// スライダー設定
// ------------------------------------------------------------------------
const indexSliderSetting = () => {
  let indexSlider = new Swiper('.tw-anime-slider .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      prevEl: '.tw-anime-slider .tw-anime-slider-nav .tw-anime-slider-nav-prev',
      nextEl: '.tw-anime-slider .tw-anime-slider-nav .tw-anime-slider-nav-next'
    },
    breakpoints: {
      960: {
        slidesPerView: 3,
      }
    },
  });
}
indexSliderSetting();



// WEBPACK FOOTER //
// ./src/assets/js/index.js